import { Publication } from '../types/publication';

export const publications: Publication[] = [
  {
    id: 'hamamura2026sca',
    type: 'inproceedings',
    title: 'Integrating Quantum and HPC: A Prototype Hybrid Implementation and Benchmark of Quantum-Selected Configuration Interaction',
    authors: [
      'Ikko Hamamura', 'Toshiyuki Imamura', 'Takashi Arakawa', 'Shinji Sumimoto',
      'Kazuya Yamazaki', 'Yao Hu', 'Shinnosuke Furuya', 'Kengo Nakajima',
    ],
    booktitle: 'Proceedings of the Supercomputing Asia and International Conference on High Performance Computing in Asia Pacific Region Workshops (SCA 2026)',
    pages: '208-218',
    year: 2026,
    doi: '10.1145/3784828.3785259',
    url: 'https://doi.org/10.1145/3784828.3785259',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2026mcp',
    type: 'inproceedings',
    title: 'A Model Context Protocol Server for Quantum Execution in Hybrid Quantum-HPC Environments',
    authors: ['Masaki Shiraishi', 'Ikko Hamamura', 'Tatsuya Ishigaki', 'Tadashi Kadowaki'],
    booktitle: '2026 International Conference on Quantum Communications, Networking, and Computing (QCNC)',
    pages: '1-6',
    year: 2026,
    doi: '10.1109/qcnc69040.2026.00145',
    url: 'https://doi.org/10.1109/qcnc69040.2026.00145',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2026dynamic',
    type: 'article',
    title: 'Efficient implementation of randomized quantum algorithms with dynamic circuits',
    authors: ['Shu Kanno', 'Ikko Hamamura', 'Rudy Raymond', 'Qi Gao', 'Naoki Yamamoto'],
    journal: 'IEEE Trans. Quantum Eng.',
    volume: '7',
    pages: '1-13',
    year: 2026,
    doi: '10.1109/TQE.2026.3671723',
    url: 'https://doi.org/10.1109/TQE.2026.3671723',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2026generative',
    type: 'misc',
    title: 'Generative Circuit Design for Quantum-Selected Configuration Interaction',
    authors: ['Ryota Kemmoku', 'Qi Gao', 'Shu Kanno', 'Kimberlee Keithley', 'Ikko Hamamura', 'Naoki Yamamoto', 'Kouhei Nakaji'],
    journal: 'arXiv:2604.09756',
    year: 2026,
    url: 'https://arxiv.org/abs/2604.09756',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2026auger',
    type: 'misc',
    title: 'Auger Spectroscopy via Generative Quantum Eigensolver: A Quantum Approach to Molecular Excitations',
    authors: [
      'Kimberlee Keithley', 'Shunsuke Yamamoto', 'Ryota Kenmoku', 'Ikko Hamamura', 'Kouhei Nakaji',
      'Shu Kanno', 'Takao Kobayashi', 'Qi Gao', 'Shumpei Uno', 'Kohei Oshio',
      'Naoki Watanabe', 'Takeshi Sato', 'Naoki Yamamoto', 'Shunya Minami', 'Yohichi Suzuki',
      'Yuma Nakamura', 'Jorge A. Campos-Gonzalez-Angulo', 'Mohammad Ghazi Vakili', 'Alán Aspuru-Guzik',
    ],
    journal: 'arXiv:2603.12859',
    year: 2026,
    url: 'https://arxiv.org/abs/2603.12859',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025diffusion',
    type: 'article',
    title: 'Synthesis of discrete-continuous quantum circuits with multimodal diffusion models',
    authors: ['Florian Fürrutter', 'Zohim Chandani', 'Ikko Hamamura', 'Hans J. Briegel', 'Gorka Muñoz-Gil'],
    journal: 'Mach. Learn.: Sci. Technol.',
    volume: '7',
    pages: '025065',
    year: 2026,
    doi: '10.1088/2632-2153/ae5b21',
    url: 'https://doi.org/10.1088/2632-2153/ae5b21',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025diagonalization',
    type: 'article',
    title: 'Diagonalization of large many-body Hamiltonians on a quantum processor',
    authors: [
      'Nobuyuki Yoshioka', 'Mirko Amico', 'William Kirby', 'Petar Jurcevic', 'Arkopal Dutt',
      'Bryce Fuller', 'Shelly Garion', 'Holger Haas', 'Ikko Hamamura', 'Alexander Ivrii',
      'Ritajit Majumdar', 'Zlatko Minev', 'Mario Motta', 'Bibek Pokharel', 'Pedro Rivero',
      'Kunal Sharma', 'Christopher J. Wood', 'Ali Javadi-Abhari', 'Antonio Mezzacapo',
    ],
    journal: 'Nature Communications',
    volume: '16',
    pages: '5014',
    year: 2025,
    doi: '10.1038/s41467-025-59716-z',
    url: 'https://doi.org/10.1038/s41467-025-59716-z',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025ai',
    type: 'article',
    title: 'Artificial Intelligence for Quantum Computing',
    authors: [
      'Yuri Alexeev', 'Marwa H. Farag', 'Taylor L. Patti', 'Mark E. Wolf', 'Natalia Ares',
      'Alán Aspuru-Guzik', 'Simon C. Benjamin', 'Zhenyu Cai', 'Shuxiang Cao', 'Christopher Chamberland',
      'Zohim Chandani', 'Federico Fedele', 'Ikko Hamamura', 'Nicholas Harrigan', 'Jin-Sung Kim',
      'Elica Kyoseva', 'Justin G. Lietz', 'Tom Lubowe', 'Alexander McCaskey', 'Roger G. Melko',
      'Kouhei Nakaji', 'Alberto Peruzzo', 'Pooja Rao', 'Bruno Schmitt', 'Sam Stanwyck',
      'Norm M. Tubman', 'Hanrui Wang', 'Timothy Costa',
    ],
    journal: 'Nature Communications',
    year: 2025,
    doi: '10.1038/s41467-025-65836-3',
    url: 'https://doi.org/10.1038/s41467-025-65836-3',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025bench',
    type: 'misc',
    title: 'QuantumBench: A Benchmark for Quantum Problem Solving',
    authors: [
      'Shunya Minami', 'Tatsuya Ishigaki', 'Ikko Hamamura', 'Taku Mikuriya', 'Youmi Ma',
      'Naoaki Okazaki', 'Hiroya Takamura', 'Yohichi Suzuki', 'Tadashi Kadowaki',
    ],
    journal: 'arXiv:2511.00092',
    year: 2025,
    url: 'https://arxiv.org/abs/2511.00092',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025ergodic',
    type: 'article',
    title: 'Observation of constructive interference at the edge of quantum ergodicity',
    authors: ['Dmitry A. Abanin', 'Rajeev Acharya', 'Xiao Mi', 'Kostyantyn Kechedzhi', 'Nicholas Zobrist', 'et al.'],
    journal: 'Nature',
    volume: '646',
    pages: '825-830',
    year: 2025,
    doi: '10.1038/s41586-025-09526-6',
    url: 'https://doi.org/10.1038/s41586-025-09526-6',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2025sano',
    type: 'article',
    title: 'Quantum State Preparation for Probability Distributions with Reflection Symmetry Using Matrix Product States',
    authors: ['Yuichi Sano', 'Ikko Hamamura'],
    journal: 'Phys. Rev. Applied',
    volume: '24',
    pages: '034062',
    year: 2025,
    doi: '10.1103/PhysRevApplied.24.034062',
    url: 'https://doi.org/10.1103/PhysRevApplied.24.034062',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2024hamiltonian',
    type: 'article',
    title: 'Hamiltonian simulation for hyperbolic partial differential equations by scalable quantum circuits',
    authors: ['Yuki Sato', 'Ruho Kondo', 'Ikko Hamamura', 'Tamiya Onodera', 'Naoki Yamamoto'],
    journal: 'Phys. Rev. Research',
    volume: '6',
    pages: '033246',
    year: 2024,
    doi: '10.1103/PhysRevResearch.6.033246',
    url: 'https://doi.org/10.1103/PhysRevResearch.6.033246',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2023vqe',
    type: 'article',
    title: 'Enhancing VQE Convergence for Optimization Problems with Problem-specific Parameterized Quantum Circuits',
    authors: ['Atsushi Matsuo', 'Yudai Suzuki', 'Ikko Hamamura', 'Shigeru Yamashita'],
    journal: 'IEICE TRANSACTIONS on Information and Systems',
    volume: 'E106-D',
    number: '11',
    pages: '1772-1782',
    year: 2023,
    doi: '10.1587/transinf.2023EDP7071',
    url: 'https://doi.org/10.1587/transinf.2023EDP7071',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2020entangled',
    type: 'article',
    title: 'Efficient evaluation of quantum observables using entangled measurements',
    authors: ['Ikko Hamamura', 'Takashi Imamichi'],
    journal: 'npj Quantum Information',
    volume: '6',
    pages: '56',
    year: 2020,
    doi: '10.1038/s41534-020-0284-2',
    url: 'https://doi.org/10.1038/s41534-020-0284-2',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2019relation',
    type: 'article',
    title: 'Relation between state-distinction power and disturbance in quantum measurements',
    authors: ['Ikko Hamamura', 'Takayuki Miyadera'],
    journal: 'J. Math. Phys.',
    volume: '60',
    number: '082103',
    year: 2019,
    doi: '10.1063/1.5109446',
    url: 'https://doi.org/10.1063/1.5109446',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2018separability',
    type: 'article',
    title: 'Separability Criterion for Quantum Effects',
    authors: ['Ikko Hamamura'],
    journal: 'Phys. Lett. A',
    volume: '382',
    number: '36',
    year: 2018,
    doi: '10.1016/j.physleta.2018.06.043',
    url: 'https://doi.org/10.1016/j.physleta.2018.06.043',
    category: 'originalPapers',
  },
  {
    id: 'hamamura2023book',
    type: 'book',
    title: '量子コンピュータシステム ―ノイズあり量子デバイスの研究開発―',
    authors: ['Yongshan Ding', 'Frederic T. Chong', '小野寺民也 (訳)', '金澤直輝 (訳)', '濵村一航 (訳)'],
    publisher: 'オーム社',
    year: 2023,
    url: 'https://www.ohmsha.co.jp/book/9784274230660/',
    category: 'books',
  },
  {
    id: 'hamamura2026patent_wirecutting',
    type: 'patent',
    title: 'Optimization of wire-cutting of quantum circuits',
    authors: ['Ikko Hamamura', 'Hiroshi Horii'],
    journal: 'US Patent Application 20260010701',
    year: 2026,
    url: 'https://patents.google.com/patent/US20260010701A1/en',
    category: 'patents',
  },
  {
    id: 'hamamura2026patent_qrandom',
    type: 'patent',
    title: 'Quantum Random Numbers with Dynamic Quantum Circuits',
    authors: ['Ikko Hamamura', 'Rudy Raymond Harry Putra', 'Shu Kanno', 'Qi Gao'],
    journal: 'US Patent Application 20260057268',
    year: 2026,
    url: 'https://patents.google.com/patent/US20260057268A1/en',
    category: 'patents',
  },
  {
    id: 'hamamura2025patent_sampling',
    type: 'patent',
    title: 'Enablement of sampling-optimization for gate-level simulation',
    authors: ['Hiroshi Horii', 'Ikko Hamamura'],
    journal: 'US Patent 12,367,411',
    year: 2025,
    url: 'https://patents.google.com/patent/US12367411B2/en',
    category: 'patents',
  },
  {
    id: 'hamamura2024patent_expectation',
    type: 'patent',
    title: 'Optimization of expectation value calculation with statevector',
    authors: ['Ikko Hamamura', 'Hiroshi Horii'],
    journal: 'US Patent Application 20240127101',
    year: 2024,
    url: 'https://patents.google.com/patent/US20240127101A1/en',
    category: 'patents',
  },
  {
    id: 'hamamura2023patent_pauli',
    type: 'patent',
    title: 'Selection of Pauli strings for variational quantum eigensolver',
    authors: ['Ikko Hamamura', 'Takashi Imamichi', 'Rudy Raymond Harry Putra'],
    journal: 'US Patent 11,275,816 / 11,636,175 / 12,430,399',
    year: 2023,
    url: 'https://patents.google.com/patent/US11636175B2/en',
    category: 'patents',
  },
  {
    id: 'hamamura2021patent_grouping',
    type: 'patent',
    title: 'Grouping of Pauli strings using entangled measurements',
    authors: ['Takashi Imamichi', 'Ikko Hamamura'],
    journal: 'US Patent 11,010,514',
    year: 2021,
    url: 'https://patents.google.com/patent/US11010514B2/en',
    category: 'patents',
  },
  {
    id: 'hamamura2020phd',
    type: 'phdthesis',
    title: '量子論と一般確率論における両立不可能性と合成系の研究',
    authors: ['濵村 一航'],
    journal: '京都大学 博士論文',
    publisher: '京都大学',
    year: 2020,
    doi: '10.14989/doctor.k22410',
    url: 'https://doi.org/10.14989/doctor.k22410',
    category: 'thesis',
  },
  {
    id: 'hamamura2017structure',
    type: 'article',
    title: '量子論における合成系の構造',
    authors: ['濵村 一航'],
    journal: '物性研究・電子版',
    publisher: '物性研究刊行会',
    volume: '6',
    number: '2',
    pages: '062601',
    year: 2017,
    doi: '10.14989/225170',
    url: 'https://dx.doi.org/10.14989/225170',
    category: 'thesis',
  },
  {
    id: 'hamamura2021ieice',
    type: 'article',
    title: '雑音のある量子コンピュータの最近の動向',
    authors: ['今道 貴司', '濵村 一航'],
    journal: '電子情報通信学会誌',
    publisher: '電子情報通信学会',
    volume: '104',
    number: '11',
    pages: '1174-1181',
    year: 2021,
    url: 'https://app.journal.ieice.org/trial/104_11/k104_11_1174/',
    category: 'kiyo',
  },
  {
    id: 'hamamura2017incompatibility',
    type: 'article',
    title: '操作の両立不可能性と情報擾乱の関係',
    authors: ['濵村 一航'],
    journal: '数理解析研究所講究録',
    publisher: '京都大学数理解析研究所',
    volume: '2059',
    pages: '113-129',
    year: 2017,
    category: 'kiyo',
  },
];
